// Lib
import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './DocumentModeCanvasElementDebugger.scss';

// The overlay colour will be picked depending on the index of the cluster it's within
const CLUSTER_COLORS = [
    'rgba(255, 255, 0, 0.5)', // yellow
    'rgba(127, 219, 255, 0.5)', // blue
    'rgba(46, 204, 64, 0.5)', // green
    'rgba(240, 18, 190, 0.5)', // maroon
    'rgba(57, 204, 204, 0.5)', // teal
    'rgba(255, 133, 27, 0.5)', // orange
    'rgba(255, 65, 54, 0.5)', // red
    'rgba(1, 255, 112, 0.5)', // lime
];

const getElementBorderStyle = (gridSize, elementClusterData, clusterIndex) => {
    const bounds = elementClusterData.getIn(['cluster', 'bounds']).toJS();
    const colourIndex = (clusterIndex - 1) % CLUSTER_COLORS.length;

    return {
        top: bounds.top * gridSize,
        left: bounds.left * gridSize,
        width: (bounds.right - bounds.left) * gridSize,
        height: (bounds.bottom - bounds.top) * gridSize,
        background: CLUSTER_COLORS[colourIndex],
    };
};

const DocumentModeCanvasElementDebugger = ({ gridSize, elementClusterData, clusterIndex, elementOrder }) => {
    const elementId = elementClusterData.getIn(['cluster', 'id']);
    const order = elementOrder.indexOf(elementId) + 1;

    return (
        <div
            className="DocumentModeCanvasElementDebugger"
            style={getElementBorderStyle(gridSize, elementClusterData, clusterIndex)}
        >
            <span className="order">{order}</span>
            <span className="element-id">{elementId.substr(-4)}</span>
        </div>
    );
};

DocumentModeCanvasElementDebugger.propTypes = {
    gridSize: PropTypes.number.isRequired,
    clusterIndex: PropTypes.number.isRequired,
    columnIndex: PropTypes.number.isRequired,
    elementClusterData: PropTypes.object.isRequired,
    elementOrder: PropTypes.object.isRequired,
};

export default DocumentModeCanvasElementDebugger;
